module.exports = __webpack_public_path__ + "static/media/etc33.9ff76c4b.png";